import "./brokerConvenienceTestTextQuestion.scss";
import React from "react";
import PropTypes from "prop-types";

import { EURO_SYMBOL } from "constants/index";

import { AmountInput } from "commonsComponents/amountInput";
import { HTMLSafeInjector } from 'commonsComponents/htmlSafeInjector';
import BrokerConvenienceTestYellowDisclaimer from "../brokerConvenienceTestYellowDisclaimer/brokerConvenienceTestYellowDisclaimer";

const BrokerConvenienceTestTextQuestion = ({
    answer,
    question,
    questionId,
    sectionId,
    onChange,
    disclaimer,
    label,
    footstep,
    invalidAnswer,
    invalidAnswerText,
}) => {
    const disclaimerComponent = disclaimer ? (
        <BrokerConvenienceTestYellowDisclaimer>
            {disclaimer}
        </BrokerConvenienceTestYellowDisclaimer>
    ) : null;

    const footstepComponent = footstep ? (
        <div className="br-convenience-text-question__footstep">
            <HTMLSafeInjector message={footstep} />
        </div>
    ) : null;

    const invalidAnswerComponent = invalidAnswer ? (
        <div className="br-convenience-text-question__error">
            {invalidAnswerText}
        </div>
    ) : null;

    return (
        <div className="robo-radial-menu">
            <div className="robo-radial-menu__title">{question}</div>
            {disclaimerComponent}
            <div className="br-convenience-text-question__container">
                <div className="br-convenience-text-question__container__row">
                    <div className="br-convenience-text-question__container__row__text">
                        {label}
                    </div>
                    <div className="br-convenience-text-question__container__row__incomings">
                        <div className="ra-input br-convenience-text-question__input">
                            <AmountInput
                                amount={answer.getIn([0, "description"])}
                                callback={(value) =>
                                    onChange(sectionId, questionId, value)
                                }
                                onChange={(value) =>
                                    onChange(sectionId, questionId, value ? parseInt(value) : 0)
                                }
                                showBlurZero={true}
                                disablePaste
                                maxFractionLength={0}
                                language={"es"}
                            />
                        </div>
                        <div className="br-convenience-text-question__container__row__symbol">
                            {EURO_SYMBOL}
                        </div>
                    </div>
                </div>
                {invalidAnswerComponent}
                {footstepComponent}
            </div>
        </div>
    );
};

BrokerConvenienceTestTextQuestion.propTypes = {
    answer: PropTypes.object.isRequired,
    question: PropTypes.string.isRequired,
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    disclaimer: PropTypes.string,
    label: PropTypes.string,
    footstep: PropTypes.string,
    invalidAnswer: PropTypes.bool,
    invalidAnswerText: PropTypes.string,
}

export default BrokerConvenienceTestTextQuestion;
